<template>
  <div class="container-position">

    <div class="area-tags">
      <label class="mb-2"><strong>{{ $t('indicador-a-ser-criado') }}</strong> {{ this.indicator }}</label>
      <p class="mb-0">{{ $t('selecione-um-indicador-da-arvore-para-definir-seus-locais') }}</p>
      <span class="insert-node">
        <b-button id="button-up" :disabled="!canAddNode" :title="$t('adicionar-a-acima')" size="sm"
          class="button-pentagro mt-1 " @click="addIndicator('up')">
          <b-icon class="mr-2" icon="box-arrow-up"></b-icon>
          {{ $t('acima') }}
        </b-button>
        <b-button id="button-down" :disabled="!canAddNode" :title="$t('adicionar-a-abaixo')" size="sm"
          class="button-pentagro mt-1 ml-2" @click="addIndicator('down')">
          <b-icon class="mr-2" icon="box-arrow-down"></b-icon>
          {{ $t('abaixo') }}
        </b-button>
        <b-button id="button-inside" :disabled="!canAddNodeInside" :title="$t('adicionar-a-dentro')" size="sm"
          class="button-pentagro mt-1 ml-2" @click="addIndicator('inside')">
          <b-icon class="mr-2" icon="box-arrow-down-right"></b-icon>
          {{ $t('dentro') }}
        </b-button>
      </span>

      <p class="mt-3 mb-0">{{ $t('selecione-um-indicador-na-area-de-tela') }}</p>
      <b-button id="button-create-screen" :disabled="!canCreateMonitoringScreen" size="sm" class="button-pentagro mt-2"
        @click="() => $bvModal.show('createMonitoringScree')">
        {{ createMonitoringScreen }}
      </b-button>

      <div class="mt-3">
        <p id="positions-info" class="clickable mb-1"><strong>{{ $t('quantidade-alocada') }} </strong>{{ allocatedAmount
        }}
          <b-icon id="position-filter" @click="selectIndicatorInTree()" class="icon-button-pentagro filter-indicator"
            :title="$t('filtrar-remover-filtro')" icon="search"></b-icon>
        </p>
        <p id="positions-info1" class="mb-1 "><strong>{{ $t('vinculado-a-tela-de-monitoramento') }}</strong> {{
          linkedToMonitoringScreen }}</p>
        <p id="positions-info2" class="mb-1 "><strong>{{ $t('nova-tela-de-monitoramento') }}</strong> {{
          newScreenMonitoring }}</p>
        <p id="positions-info3" class="mb-1 "><strong>{{ $t('nova-area-de-monitoramento') }}</strong> {{ newAreaScreen }}
        </p>
      </div>
      <b-icon id="clear-references" class="icon-button-pentagro left-position mr-2 mt-1" :title="$t('limpar-referencias')"
        icon="eraser" @click="() => $bvModal.show('askCleanReferences')"></b-icon>
    </div>

    <div class="area-tree">
      <label>{{ $t('arvore-de-indicadores') }}</label>
      <b-form-input :id="`filter-tree`" size="sm" v-model="findNode" :placeholder="$t('filtrar-arvore') + '...'">
      </b-form-input>
      <div class="tree-structure">
        <tree ref="tree" v-if="!loading" class="tree-indicator" :data="tree" :options="treeOptions" :filter="findNode"
          @node:selected="onNodeSelected">
          <div slot-scope="{ node }" class="node-container">
            <div :id="'tag_' + node.id" v-if="!node.data.newIndicator && !node.data.newScreen" :title="node.text"
              :class="{ 'node-root': node.data.model && node.data.model.indicatorRule.includes('root') }">
              {{ node.text }}
            </div>
            <div :id="'tag_' + node.id" v-else-if="node.data.newIndicator" class="new-indicator">
              <span @click="removeIndicator(node)" :title="$t('remover-indicador')" class="close-new-indicator">x</span>
              <label class="mb-0">{{ node.text }}</label>
            </div>
            <div :id="'newScreen_' + node.id" v-else class="new-Screen">
              <span v-if="node.children.length == 0" @click="removeScreen(node)" class="close-new-screen"
                :title="$t('remover-linha')">x</span> <label class="screen-position mb-0">{{ node.text }}</label>
            </div>
          </div>
        </tree>
        <p v-else>{{ $t('carregando-arvore-de-indicadores') }}</p>
      </div>
      <b-icon id="next-step" class="icon-button-pentagro left-position mr-2 mt-1" :title="$t('proximo')"
        icon="arrow-right" @click="next"></b-icon>

      <b-modal id="createMonitoringScree" :title="$t('criar-tela-de-monitoramento')" cancel-variant="danger"
        ok-variant="success" :ok-title="$t('criar')" :cancel-title="$t('cancel')" @ok="createScreem()">
        <div>
          <label v-if="createScreeMonitoring" for="newMonitoring">{{ $t('nome-da-tela-de-monitoramento') }}</label>
          <b-form-input v-if="createScreeMonitoring" id="newMonitoring" size="sm" v-model="nameNewScreen"
            placeholder="Ex: COI">
          </b-form-input>
          <label class="mt-2" for="newAreaMonitoring">{{ $t('nome-da-area-0') }}</label>
          <b-form-input id="newAreaMonitoring" size="sm" v-model="nameNewAreaScreen" :placeholder="$t('ex-extracao')">
          </b-form-input>
          <p v-if="!this.isScreenWithoutChild" class="mt-2" for="newAreaMonitoring">{{ $t('posicao-selecionada') + " "
          }}{{ canAddAreaInside || createScreeMonitoring ? newScrennPosition : new this.$t('dentro') }}</p>
          <p v-else class="mt-2" for="newAreaMonitoring">{{ $t('posicao-selecionada') + " Dentro" }}</p>
          <b-button :title="$t('adicionar-a-acima')"
            v-if="(canAddAreaInside || this.createScreeMonitoring) && !this.isScreenWithoutChild" size="sm"
            class="button-pentagro mt-1 " @click="() => { newScrennPosition = this.$t('acima') }">
            <b-icon class="mr-2" icon="box-arrow-up"></b-icon>
            {{ $t('acima') }}
          </b-button>
          <b-button v-if="(canAddAreaInside || this.createScreeMonitoring) && !this.isScreenWithoutChild"
            :title="$t('adicionar-a-abaixo')" size="sm" class="button-pentagro mt-1 ml-2"
            @click="() => { newScrennPosition = $t('abaixo') }">
            <b-icon class="mr-2" icon="box-arrow-down"></b-icon>
            {{ $t('abaixo') }}
          </b-button>
        </div>
      </b-modal>

      <b-modal id="askCleanReferences" :title="$t('atention')" ok-variant="danger" :ok-title="$t('yes')"
        :cancel-title="$t('no')" @ok="cleanReferences">{{ $t('ask-clean-position') }}</b-modal>
    </div>
  </div>
</template>

<script>
import Tree from "liquor-tree";
import Mediator from '../../utilities/Mediator';
import { showError } from '../../../../../global';

export default {
  name: "Manage-Positioning",
  components: { Tree },
  props: ["sourceTree"],

  data() {
    return {
      isScreenWithoutChild: false,
      step: "step-4",
      nextStep: "step-5",
      createMonitoringScreen: this.$t('create-screen-monitoring'),
      indicator: "",
      tree: this.sourceTree,
      allocatedAmount: 0,
      linkedToMonitoringScreen: this.$t('no'),
      addedToScreen: [],
      newAreaScreen: this.$t('no'),
      newScreenMonitoring: this.$t('no'),
      findNode: "",
      loading: false,
      treeOptions: {
        filter: {
          emptyText: this.$t('nao-foi-encontrado-resultados'),
          matcher(query, node) {
            return new RegExp(query, 'i').test(node.text)
          },
          plainList: false,
          showChildren: false
        }
      },

      transientId: 0,
      nodeSelected: {},
      canCreateMonitoringScreen: false,
      createScreeMonitoring: true,
      nameNewScreen: "",
      nameNewAreaScreen: "",
      newScrennPosition: "-",
      currentScreenModified: "",
      scresnWasModified: [],
      countPositions: 0,
      notUpdateChangeScreen: true
    }
  },

  computed: {
    canAddNode() {
      let validId = !isNaN(this.transientId) && this.transientId != 0
      let hasParent = this.nodeSelected.parent
      let hasParentParent = hasParent && this.nodeSelected.parent.parent
      let alreadyIncluded = hasParentParent && this.addedToScreen.includes(this.nodeSelected.parent.parent.data.text)
      let areaLevel = hasParent && this.nodeSelected.parent.data.text.toLowerCase().includes(this.$t('screen').toLowerCase() + " ")
      let screenLevel = hasParent && this.nodeSelected.parent.data.text.toLowerCase().includes(this.$t('screens').toLowerCase());
      screenLevel = this.nodeSelected.data && this.nodeSelected.data.text.toLowerCase().includes(this.$t('screen').toLowerCase()) || screenLevel;

      return validId && !alreadyIncluded && !areaLevel && !screenLevel;
    },

    canAddNodeInside() {
      let hasParentParent = this.nodeSelected.parent && this.nodeSelected.parent.parent  // Há avo
      
      let hasParentParentScreen = hasParentParent && this.nodeSelected.parent.parent.data.text.toLowerCase().includes(this.$t('screen').toLowerCase() + " ")
      
      let parentMonitoringMainScreen = hasParentParent && this.nodeSelected.parent.parent.data.text.toLowerCase().includes(this.$t('screens').toLowerCase() + " ")

      let addAnIndicatorInAnExistingScreen = 
                   !hasParentParentScreen && //o avô com nome TELA
                   !isNaN(this.transientId) && //não é uma área que foi criada agora
                   this.transientId != 0 &&
                   !this.alreadyIncluded && 
                   !this.nodeSelected.data.text.toLowerCase().includes(this.$t('screen').toLowerCase()) && //o nós selecionado não pode ser uma tela
                   !this.addedToScreen.includes(this.nodeSelected.data.text);


      let addIndicatorInNewScreen = 
                   hasParentParent && //existe avô
                   !this.addedToScreen.includes(this.nodeSelected.data.text) &&  // Não foi adicionado na tela
                   !this.alreadyIncluded && // Já foi incluído na tela
                   !this.nodeSelected.data.text.toLowerCase().includes(this.$t('screen').toLowerCase()) && // Não esta sobre a tela
                   parentMonitoringMainScreen &&
                   this.nodeSelected.children.length == 0 && // não Tem filhos
                   this.nodeSelected.data.text != this.indicator; // o nome é diferente do indicador
      
      return addAnIndicatorInAnExistingScreen || addIndicatorInNewScreen;
    },

    alreadyIncluded() {
      return (this.nodeSelected.parent &&
        this.addedToScreen.includes(this.nodeSelected.parent.data.text)) ||
        (this.nodeSelected.parent.parent &&
          this.addedToScreen.includes(this.nodeSelected.parent.parent.data.text))
    },

    canAddAreaInside() {
      return !isNaN(this.nodeSelected.id)
    }
  },

  watch: {
    nameNewScreen(value) {
      this.nameNewScreen = this.removeSpecialCharacteres(value)
    },

    nameNewAreaScreen(value){
      this.nameNewAreaScreen = value.replaceAll(this.$t('screen').toUpperCase(),"").replaceAll(this.$t('screen').toLowerCase(),"").replaceAll(this.$t('screen'),"")
    },

    // Se estiver inicializando não faz nada
    countPositions() {

      if (!this.notUpdateChangeScreen) {
        
        this.scresnWasModified.push(this.currentScreenModified);
      }
    }
  },

  methods: {
    removeSpecialCharacteres(name) {
      return name.replace(/[^A-z0-9\s]/, "");
    },

    countAmount() {
      this.allocatedAmount = Mediator.indicator.positions.length
    },

    createScreem() {
      let position = 'inside'

      if (!isNaN(this.nodeSelected.id) && !this.isScreenWithoutChild)
        position = this.newScrennPosition == this.$t('acima') || this.newScrennPosition == "-" ?
          "up" : this.newScrennPosition == this.$t('abaixo') ? "down" : "inside"

      if (this.nameNewAreaScreen.toUpperCase().includes(this.$t('screen').toUpperCase()) || this.nameNewAreaScreen.split(' ').find(text => text.toUpperCase() == this.$t('screen').toUpperCase())) showError("O nome da área não pode conter a palavra 'TELA'.")

      if (this.nameNewScreen.toUpperCase().includes(this.$t('screen').toUpperCase() || this.nameNewScreen.split(' ').find(text => text.toUpperCase() == this.$t('screen').toUpperCase()))) this.nameNewScreen = this.nameNewScreen.replaceAll(this.$t('screen').toUpperCase(),"").replaceAll(this.$t('screen').toLowerCase(),"").replaceAll(this.$t('screen'),"")
      
      this.nameNewScreen = this.nameNewScreen ? `${this.$t('screen')} ${this.nameNewScreen}` : ""
      
      let newScreen = null

      if ((!this.nameNewScreen && !this.nameNewAreaScreen) || (this.createScreeMonitoring && !this.nameNewScreen)) {
        showError(this.$t('preencha-todos-os-campos-para-criar-uma-tela'));
        return
      }

      if (this.nameNewScreen && !this.nameNewAreaScreen) {
        showError(this.$t('para-criar-uma-tela-e-necessario-criar-uma-area-tambem'));
        return
      }

      if (this.nameNewScreen && this.nameNewAreaScreen) {
        newScreen = this.buildNode(position, this.nodeSelected, this.nameNewScreen, true)
        this.setNewNode(position, newScreen, this.nodeSelected)
        setTimeout(() => {
          let screem = this.$refs.tree.find(i => {
            return i.data.text == this.nameNewScreen
          })

          let newArea = this.buildNode("inside", screem[0], this.nameNewAreaScreen, true)
          screem[0].append(newArea)

          setTimeout(() => {
            Mediator.notify(screem[0], "add-screen")
            this.newScreenMonitoring = this.$t('yes');
            this.newAreaScreen = this.$t('yes');
          }, 50);
        }, 90);

      } else if (this.nameNewScreen) {
        let newScreen = this.buildNode(position, this.nodeSelected, this.nameNewScreen, true)
        this.setNewNode(position, newScreen, this.nodeSelected)

        setTimeout(() => {
          newScreen = this.$refs.tree.find(i => i.data.text == this.nameNewScreen)[0]
          this.newScreenMonitoring = this.$t('yes');
          Mediator.notify(newScreen, "add-screen")
        }, 60);
      } else if (this.nameNewAreaScreen) {
        let newArea = this.buildNode(position, this.nodeSelected, this.nameNewAreaScreen, true)
        this.setNewNode(position, newArea, this.nodeSelected)

        setTimeout(() => {
          newArea = this.$refs.tree.find(i => i.data.text == this.nameNewAreaScreen)[0]
          this.newAreaScreen = this.$t('yes');
          Mediator.notify(newArea, "add-screen")
        }, 60);
        
      }

      setTimeout(() => {
        this.nameNewScreen = "";
        this.nameNewAreaScreen = "";
        this.checkCreateMonitoringScreen();
      }, 150);
    },

    checkCreateMonitoringScreen() {
      this.createScreeMonitoring = true;
      this.canCreateMonitoringScreen = false;
      let validIndicator = this.transientId != 0 || isNaN(this.nodeSelected.id);
      if (!validIndicator) return

      this.isScreenWithoutChild = this.nodeSelected.children.length == 0 && this.nodeSelected.data.text.toLowerCase().includes(this.$t('screen').toLowerCase())

      let isSecondNivel = this.nodeSelected.parent && !this.nodeSelected.parent.parent
      let screenAlreadyCreated = this.newScreenMonitoring == this.$t('yes');
      let allScreensCreated = this.newAreaScreen == this.$t('yes') && screenAlreadyCreated;
      let parentIsScreen = this.nodeSelected.parent && this.nodeSelected.parent.data.text.toLowerCase().includes(this.$t('screen').toLowerCase())
      let isScreen = this.nodeSelected.data.text.toLowerCase().includes(this.$t('screen').toLowerCase()) && !isSecondNivel

      if ((isScreen || parentIsScreen) && !allScreensCreated) {
        if (this.nodeSelected.data.text.toLowerCase().includes(this.$t('screen').toLowerCase()) && !screenAlreadyCreated) {
          this.createMonitoringScreen = this.$t('create-screen-monitoring');
          this.createScreeMonitoring = true;
        } else {
          this.createMonitoringScreen = this.$t('create-area-monitoring');
          this.createScreeMonitoring = false;
        }
        this.canCreateMonitoringScreen = true
      }

      if (this.isScreenWithoutChild) {
        this.createMonitoringScreen = this.$t('create-screen-monitoring');
        this.createScreeMonitoring = true;
        this.canCreateMonitoringScreen = true
      }
    },

    onNodeSelected(node) {
      if (node.data.model.indicatorRule && node.data.model.indicatorRule.includes("rootnode")) {
        this.transientId = 0
      } else {
        this.transientId = node.data.model.indicatorId
        this.nodeSelected = node
      }

      this.checkCreateMonitoringScreen()
    },

    selectIndicatorInTree() {
      if (this.findNode == this.indicator) {
        this.findNode = ""
      } else {
        this.findNode = this.indicator
      }

    },

    addIndicator(position) {
      if (this.nodeSelected.data.newIndicator || this.nodeSelected.data.model.indicatorRule == "rootnode") {
        showError(this.$t('por-favor-selecione-outro-indicador'))
        return;
      }

      // console.log("NODE:", this.nodeSelected)
      // console.log("POS:", position)
      // console.log("IND:", this.indicator)

      let node = this.buildNode(position, this.nodeSelected, this.indicator)
      this.setNewNode(position, node, this.nodeSelected)
      
      Mediator.notify(node.data.keyNodeSelected, "add-position")
      this.countAmount()
      this.checkAnyIndicatorInMonitoringScreen()
    },

    setNewNode(position, newNode, targetNode) {
      if (position == "up" || position == "-") {
        targetNode.before(newNode)
      }
      else if (position == "down") {
        targetNode.after(newNode)
      } else {
        targetNode.append(newNode)
      }
    },

    removeIndicator(node) {
      if (!this.$refs.tree) return

      // Remove a tela das screens.
      if (node.parent.parent && this.addedToScreen.includes(node.parent.parent.text)) {
        let screen = node.parent.parent.text
        this.addedToScreen.splice(this.addedToScreen.indexOf(screen), 1)
      }

      // Remove a tela das screens modificadas.
      if (node.parent.parent && this.scresnWasModified.includes(node.parent.parent.text)) {
        let screen = node.parent.parent.text
        this.scresnWasModified.splice(this.scresnWasModified.indexOf(screen), 1)
        this.notUpdateChangeScreen = true;
      }

      // Libera o observer que monitora mudança de posição.
      setTimeout(() => this.notUpdateChangeScreen = false, 200);

      this.$refs.tree.remove(node)

      Mediator.notify(node.data.keyNodeSelected, "remove-position")
      this.countAmount()
      this.checkAnyIndicatorInMonitoringScreen()
    },

    removeScreen(node) {
      this.$refs.tree.remove(node)

      if (node.data.text.toLowerCase().includes(this.$t('screen').toLowerCase()))
        this.newScreenMonitoring = this.$t('no');
      else
        this.newAreaScreen = this.$t('no');

      Mediator.notify(node, "remove-screen")
    },

    buildNode(position, nodeTarget, text, newScreen, id) {
      let model = nodeTarget.data.model
      if (model.indicatorId == 0)
      {
        model.indicatorId = nodeTarget.id
      }
      
        return {
        id: id,
        text: text,
        data: {
          keyNodeSelected: `${position}|${model.indicatorId}|${model.productionUnitId}|${model.system}|${model.id}|${this.isScreenWithoutChild}`,
          newIndicator: !newScreen,
          newScreen: newScreen,
          text: text,
          model: {
            indicatorId: 0,
            system: model.system,
            productionUnitId: model.productionUnitId,
            treeSequence: model.treeSequence
          }
        },
        children: []
      }
    },

    checkAnyIndicatorInMonitoringScreen() {
      let positions = Mediator.indicator.positions
      this.linkedToMonitoringScreen = this.$t('no');
      for (const p of positions) {
        let nodeFound = this.getNodeByPosition(p)
        if (!nodeFound.target) continue;
        this.checkIndicatorMonitoringScreen(nodeFound.target)
      }

    },

    checkIndicatorMonitoringScreen(node) {
      let parent = node.parent;
      if (!parent || !parent.parent) return

      if (parent.parent.text.toLowerCase().includes(this.$t('screen').toLowerCase()) || this.linkedToMonitoringScreen == this.$t('yes')) {
        this.linkedToMonitoringScreen = this.$t('yes')
        
        let canAddParentScreen = parent.data.text.includes(this.$t("screen") + " ") || parent.parent.text.includes(this.$t("screen") + " ")
        
        if (!this.addedToScreen.includes(parent.parent.data.text) && canAddParentScreen) {
          if(parent.parent.data.text.includes(this.$t("screens") + " ")){

            this.addedToScreen.push(parent.data.text)
          }else{
            this.addedToScreen.push(parent.parent.data.text)
          }
          this.currentScreenModified = parent.data.text.includes(this.$t("screen") + " ") ? parent.data.text : parent.parent.data.text;
          this.countPositions++;
        }
      }
      else {
        this.linkedToMonitoringScreen = this.$t('no')
        this.addedToScreen = []
      }

      Mediator.notify({
        allocatedAmount: this.allocatedAmount,
        linkedToMonitoringScreen: this.linkedToMonitoringScreen,
        newAreaScreen: this.newAreaScreen,
        newScreenMonitoring: this.newScreenMonitoring,
        scresnWasModified: this.scresnWasModified,
      }, "update-note")
    },

    ifAlreadyExistsClearAll() {
      if (!this.$refs.tree) return
      var indicatorName = Mediator.indicator.getIndicatorName();
      this.$refs.tree.find(i => {
        if (i.text == indicatorName)
          i.remove()
      })
    },

    initStashPositions() {
      this.ifAlreadyExistsClearAll()
      let createScreen = JSON.parse(JSON.stringify(Mediator.indicator.createScreen))

      let countChildrens = 0;
      for (const screen of createScreen) {
        let { position, target } = this.getNodeByPosition(screen.data.keyNodeSelected)
        if (!target) continue

        let node = this.buildNode(position, target, screen.text, true, screen.id)
        this.setNewNode(position, node, target)
        this.newScreenMonitoring = this.$t('yes');
        if (screen.children.length == 0) continue;
        countChildrens += screen.children.length;
        setTimeout(() => {
          for (const children of screen.children) {
            let screemFound = this.$refs.tree.find(i => {
              return i.id == screen.id
            })
            if (screemFound[0])
              screemFound[0].append(children)
            else {
              screemFound = this.$refs.tree.find(i => {
                return i.text == screen.text
              })
              screemFound[0].append(children)
            }

            this.newAreaScreen = this.$t('yes');
          }
        }, 40);
      }

      setTimeout(() => {
        this.initPositions();
      }, 60 * countChildrens);
    },

    initPositions() {
      let positions = Mediator.indicator.positions
      this.linkedToMonitoringScreen = this.$t('no');
      for (let p of positions) {
        let { position, target } = this.getNodeByPosition(p)

        if (!target) continue
        this.checkIndicatorMonitoringScreen(target)
        let node = this.buildNode(position, target, this.indicator)
        this.setNewNode(position, node, target)
      }
    },

    getNodeByPosition(locale) {
      let split = locale.split("|")
      let position = split[0];
      let indicatorId = split[1];
      let productionUnitId = split[2];
      let system = split[3];
      let treeId = split[4];

      return {
        position,
        target: this.$refs.tree.find(n => {
          let model = n.data.model

          if (n.id == indicatorId && isNaN(indicatorId)) return true
          if (!model) return false

          return model.indicatorId == indicatorId &&
            model.productionUnitId == productionUnitId &&
            model.system == system &&
            model.id == treeId
        })[0]
      }
    },

    cleanReferences() {
      Mediator.notify(null, "clean-positions")
      this.loading = true;
      this.tree = {}
      this.countAmount()
      setTimeout(() => {
        this.loading = false;
        this.tree = this.sourceTree
        this.linkedToMonitoringScreen = this.$t('no');
        this.newScreenMonitoring = this.$t('no');
        this.newAreaScreen = this.$t('no');
        this.addedToScreen = []
      }, 100);
    },

    next() {
      Mediator.notify(this, "select-step-by-form")
    },
  },

  mounted() {
    this.indicator = Mediator.indicator.indicatorName
    this.countAmount()
    setTimeout(() => {
      this.initStashPositions();
      setTimeout(() => {
        this.notUpdateChangeScreen = false;
      }, 1000);
    }, 50);
  },
}
</script>

<style scoped>
.container-position {
  display: grid;
  grid-template-columns: 38.2% 61.8%;
  gap: 8px;
  height: 69vh;
  width: 100%;
}

.area-tree,
.area-tags {
  display: flex;
  flex-direction: column;
  height: inherit;
  width: 100%;
  background-color: #00000005;
  box-shadow: 0 0 3px #00000018;
  border-radius: 4px;
  margin: 3px 0;
  padding: 0px 8px;
}

.tree-indicator {
  background-color: #00000005;
  box-shadow: 0 0 3px #00000018;
  margin-top: 5px;
  border-radius: 4px;
}

.tree-structure {
  height: calc(100% - 107px);
  overflow-y: auto;
}

.indicator-to-move {
  padding: 4px 8px;
  background-color: #ff04;
  border-radius: 4px;
  cursor: pointer;
}

.indicator-to-move>p {
  margin: 0;
}

.node-container {
  display: flex;
}

.node-root {
  font-weight: 700;
}

.new-indicator {
  border: 1px solid #ff5f00;
  padding: 4px;
  border-radius: 4px;
}

.new-indicator>span {
  font-weight: 600;
  color: #800;
  text-align: center;
  font-size: 18px;
  width: 10px;
  padding: 0 4px;
}

.filter-indicator {
  cursor: pointer;
  font-size: 13px;
}

.insert-node {
  display: flex;
  justify-content: space-between;
}

.insert-node>button {
  width: 32%;
}

.close-new-screen,
.new-Screen {
  font-weight: 500;
  border-bottom: 1px solid #ff5f00;
  padding: 2px 4px;
}

.close-new-screen {
  color: #800;
  border: none
}

.new-indicator>span:hover,
.close-new-screen:hover {
  color: #f00;
}

@media (min-height: 770px) {
  .container-position {
    height: 76.6vh;
  }
}
</style>

<style>
.tree-structure>.tree {
  overflow-x: hidden;
}
</style>
